import { handleOpenMenu, handleOpenMenuMobile } from '@lib/store/slices/ComponentsSlice';
import { menuLeftSelector, menuRightSelector } from '@lib/store/slices/ProjectSlice';
import { SCHEMA } from '@lib/tools/helpers/constants';
import { useViewport } from '@lib/tools/hooks/useViewport';
import Link from 'next/link';
import { useDispatch, useSelector } from 'react-redux';
import LoaderCircle from '../loader-circle/LoaderCircle';
import style from './ModalMenuRoutes.module.scss';

const ModalMenuRoutes = () => {
  const dispatch = useDispatch();
  const { isMobile } = useViewport();

  const menuLeft = useSelector(menuLeftSelector);
  const menuRight = useSelector(menuRightSelector);

  return (
    <>
      {menuLeft?.menuItems?.length > 0 && (
        <div className={style.modalMenuRoutes} itemScope itemType={SCHEMA.SITE_NAVIGATION_ELEMENT}>
          <div className={style.modalMenuRoutes__box}>
            {menuLeft?.menuItems?.map(el => {
              if (el.path.includes('contest'))
                return (
                  <div
                    key={el.path}
                    onClick={() =>
                      !isMobile ? dispatch(handleOpenMenu(false)) : dispatch(handleOpenMenuMobile(false))
                    }
                  >
                    <a href={el?.path} className={style.modalMenuRoutes__route} itemProp='url'>
                      <span itemProp='name'>{el?.value}</span>
                    </a>
                  </div>
                );
              return (
                <Link
                  key={el.path}
                  onClick={() => (!isMobile ? dispatch(handleOpenMenu(false)) : dispatch(handleOpenMenuMobile(false)))}
                  className={style.modalMenuRoutes__route}
                  href={el?.path}
                  itemProp='url'
                >
                  <span itemProp='name'>{el?.value}</span>
                </Link>
              );
            })}
          </div>
          <div className={style.modalMenuRoutes__box}>
            {menuRight?.menuItems?.map(el => {
              if (el.path.includes('contest'))
                return (
                  <div
                    key={el.path}
                    onClick={() =>
                      !isMobile ? dispatch(handleOpenMenu(false)) : dispatch(handleOpenMenuMobile(false))
                    }
                  >
                    <a href={el?.path} className={style.modalMenuRoutes__route} itemProp='url'>
                      <span itemProp='name'>{el?.value}</span>
                    </a>
                  </div>
                );
              return (
                <Link
                  key={el.path}
                  onClick={() => (!isMobile ? dispatch(handleOpenMenu(false)) : dispatch(handleOpenMenuMobile(false)))}
                  className={style.modalMenuRoutes__route}
                  href={el?.path}
                  itemProp='url'
                >
                  <span itemProp='name'>{el?.value}</span>
                </Link>
              );
            })}
          </div>
        </div>
      )}
      {menuLeft?.menuItems?.length === (0 || undefined) && (
        <div className={style.loaderWrapper}>
          <LoaderCircle someStyles={style.loader} />
        </div>
      )}
    </>
  );
};

export default ModalMenuRoutes;
